// Base
import "../faust.config";
// import { React, useState, useEffect, useCallback } from "react";
import { useEffect, React } from "react";
import { useRouter } from "next/router";
import { FaustProvider } from "@faustwp/core";
import localFont from "next/font/local";

// Script Components
import { Gtm } from "@/components/scripts/gtm";
import { HotJar } from "@/components/scripts/hotjar";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

// Styles
import "@/styles/globals.scss";

// Components
// import Button from "@/components/button/button";
// import IconFA from "@/components/icon-fa/icon-fa";

// import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
// if (process.env.NODE_ENV !== "production") {
//   // Adds messages only in a dev environment
//   loadDevMessages();
//   loadErrorMessages();
// }

const mnkymarcel = localFont({
  src: [
    {
      path: "../public/fonts/mnkymarcel-semibold.woff",
      weight: "normal",
      style: "normal",
      display: "swap",
      preload: true,
    },
    {
      path: "../public/fonts/mnkymarcel-semibold.woff2",
      weight: "normal",
      style: "normal",
      display: "swap",
      preload: true,
    },
  ],
});

export default function MyApp({ Component, pageProps }) {
  useEffect(() => {
    CookieConsent.run({
      /**
       * All config. options available here:
       * https://cookieconsent.orestbida.com/reference/configuration-reference.html
       */
      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        analytics: {
          enabled: true,
        },
      },

      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We value your privacy",
              description:
                'We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
              acceptAllBtn: "Accept all",
              // acceptNecessaryBtn: "Reject all",
              showPreferencesBtn: "Customize",
            },
            preferencesModal: {
              title: "Manage cookie preferences",
              acceptAllBtn: "Accept all",
              // acceptNecessaryBtn: "Reject all",
              savePreferencesBtn: "Accept current selection",
              closeIconLabel: "Close modal",
              sections: [
                // {
                //   title: "Somebody said ... cookies?",
                //   description: "I want one!",
                // },
                {
                  title: "Strictly Necessary cookies",
                  description:
                    "These cookies are essential for the proper functioning of the website and cannot be disabled.",

                  //this field will generate a toggle linked to the 'necessary' category
                  linkedCategory: "necessary",
                },
                {
                  title: "Performance and Analytics",
                  description:
                    "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
                  linkedCategory: "analytics",
                },
                // {
                //   title: "More information",
                //   description:
                //     'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>',
                // },
              ],
            },
          },
        },
      },

      onConsent: function () {
        if (CookieConsent.acceptedCategory("analytics")) {
          // Analytics category enabled
        }
      },

      onChange: function ({ changedCategories, changedServices }) {
        if (changedCategories.includes("analytics")) {
          if (CookieConsent.acceptedCategory("analytics")) {
            // Analytics category was just enabled
          } else {
            // Analytics category was just disabled
          }
        }
      },
    });
  }, []);

  // -- Router
  const router = useRouter();

  // -- States
  // const [pageFadeState, setPageFadeState] = useState("off"); // Transition Page Fade In
  // const [pageScrollState, setPageScrollState] = useState("off");

  // -- Variables

  // const gtmID = pageProps.__APOLLO_STATE__?.["GeneralSettingsACF:6765bcd9cca51"]?. ?? "";
  // const gtmID = "";

  // const genAnimations =
  //   pageProps.__APOLLO_STATE__?.["GeneralSettingsACF:6765bcd9cca51"]?.animations
  //     ?.animationsOptions ?? [];

  // // -- Animations -- States & Effects

  // // - Page Transition Fade In
  // if (genAnimations.includes("page-transition")) {
  //   // Effect
  //   useEffect(() => {
  //     setPageFadeState("on");
  //     setTimeout(function () {
  //       setPageFadeState("off");
  //     }, 400);
  //   }, [router]);
  // }

  // // - Scroll To Top Button
  // if (genAnimations.includes("scroll-top")) {
  //   // On Scroll
  //   const onScroll = useCallback((event) => {
  //     const { outerHeight, scrollY } = window;
  //     const windowBottom = scrollY + outerHeight - 100;
  //     if (windowBottom > outerHeight) {
  //       setPageScrollState("on");
  //     } else {
  //       setPageScrollState("off");
  //     }
  //   }, []);

  //   // Effect
  //   useEffect(() => {
  //     window.addEventListener("scroll", onScroll, { passive: true }); // add eventlistener to window
  //     return () => {
  //       // remove event on unmount to prevent a memory leak with the cleanup
  //       window.removeEventListener("scroll", onScroll, { passive: true });
  //     };
  //   }, []);
  // }

  return (
    <FaustProvider pageProps={pageProps} className={mnkymarcel.className}>
      {/* favicon */}
      <link rel="icon" type="image/x-icon" href="/favicon.ico" sizes="any" />

      {/* Scripts */}
      <Gtm />
      <HotJar />

      {/* <div className="transitions">
        {genAnimations.includes("page-transition") && (
          <div className="transitions-page" state={pageFadeState} />
        )}
        {genAnimations.includes("scroll-top") && (
          <div className="transitions-btn" state={pageScrollState}>
            <Button
              className="btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              ariaAtts={{
                "aria-label": "scroll to the top of the page",
              }}
            >
              <IconFA name="faChevronDown" color="var(--color--font)" />
            </Button>
          </div>
        )}
      </div> */}

      <Component {...pageProps} key={router.asPath} />
    </FaustProvider>
  );
}
